/**
 * The backend's proxy and bot categories — what an anti-adblock rule can refuse
 * traffic from.
 *
 * `BLOCKABLE_PROXY_TYPE_IDS` is what a form offers, in that order; build its options from
 * it and `ProxyTypeLabels`. **`Other` is deliberately absent from both** — the backend
 * sends the id, but there is no rule to write about it, so a label for it would offer a
 * choice nothing acts on. Read labels defensively: the map is keyed by `number` for
 * that reason.
 */
export const ProxyType = {
  Vpn: 1,
  Tor: 2,
  DataCenter: 3,
  PublicProxy: 4,
  WebProxy: 5,
  Other: 6,
  SearchEngine: 7
} as const

export type ProxyTypeId = (typeof ProxyType)[keyof typeof ProxyType]

export const ProxyTypeLabels: Record<number, string> = {
  [ProxyType.Vpn]: 'Anonymizing VPN services',
  [ProxyType.Tor]: 'Tor Exit Nodes',
  [ProxyType.DataCenter]: 'Hosting Provider, Data Center or CDN',
  [ProxyType.PublicProxy]: 'Public Proxies',
  [ProxyType.WebProxy]: 'Web Proxies',
  [ProxyType.SearchEngine]: 'Search Engine Robots'
}

export const BLOCKABLE_PROXY_TYPE_IDS = [
  ProxyType.Vpn,
  ProxyType.Tor,
  ProxyType.DataCenter,
  ProxyType.PublicProxy,
  ProxyType.WebProxy,
  ProxyType.SearchEngine
] as const
